import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { onSignedOut, SESSION_KEY } from '@qor/web-shared';
import { App, createQueryClient } from './App';
import './shared/styles/tokens.css';
import './shared/styles/login.css';
import './styles/customer.css';

const queryClient = createQueryClient();
// The API ended the session (signed out elsewhere, password changed, account closed): read it again, which signs out.
onSignedOut(() => void queryClient.invalidateQueries({ queryKey: SESSION_KEY }));

const root = document.getElementById('root');
if (root)
  createRoot(root).render(
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App queryClient={queryClient} />
    </BrowserRouter>,
  );
